var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": " Quick Edit",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "1400px",
      "top": "1vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "autocomplete": "off",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Basic Information")]), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Client code",
      "prop": "clientCode"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "placeholder": "Enter number",
      "maxlength": "30",
      "show-word-limit": ""
    },
    model: {
      value: _vm.dataForm.clientCode,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "clientCode", $$v);
      },
      expression: "dataForm.clientCode"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("c")])], 2)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "UEN",
      "prop": "uen"
    }
  }, [_c('uen-input-remote-search', {
    staticClass: "wdb100",
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.dataForm.uen,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "uen", $$v);
      },
      expression: "dataForm.uen"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "country"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "disabled": "",
      "filterable": "",
      "clearable": "",
      "placeholder": "Select Country"
    },
    model: {
      value: _vm.dataForm.country,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "country", $$v);
      },
      expression: "dataForm.country"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: "basic-".concat(item.value),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company Name",
      "prop": "companyName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "placeholder": "Full legal name",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "companyName", $$v);
      },
      expression: "dataForm.companyName"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Attention",
      "prop": "attention"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Attn: Person / Dept",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.attention,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "attention", $$v);
      },
      expression: "dataForm.attention"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Coordinator",
      "prop": "coordinatorIds"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "placeholder": "Select Coordinator"
    },
    model: {
      value: _vm.dataForm.coordinatorIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "coordinatorIds", $$v);
      },
      expression: "dataForm.coordinatorIds"
    }
  }, _vm._l(_vm.userList, function (item) {
    return _c('el-option', {
      key: "client-alert-".concat(item.id),
      attrs: {
        "label": item.nickname || item.username,
        "value": item.id
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Description",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "autosize": {
        minRows: 3
      },
      "resize": "none",
      "placeholder": "Description"
    },
    model: {
      value: _vm.dataForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "remark", $$v);
      },
      expression: "dataForm.remark"
    }
  })], 1)], 1)], 1)], 1), _c('el-card', {
    staticClass: "mt10 box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Commission")]), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Introduced By",
      "prop": "introducedBy"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.dataForm.introducedBy,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "introducedBy", $$v);
      },
      expression: "dataForm.introducedBy"
    }
  }, _vm._l(_vm.introducedByList, function (item) {
    return _c('el-option', {
      key: "introducedBy".concat(item.title),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm.dataForm.introducedBy == 1 ? _c('el-form-item', {
    staticClass: "selectDisabled",
    attrs: {
      "label": "Commission",
      "prop": "commissionList"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "disabled": "",
      "value-key": "id",
      "filterable": "",
      "clearable": "",
      "multiple": "",
      "placeholder": "Please Select"
    },
    model: {
      value: _vm.dataForm.commissionList,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "commissionList", $$v);
      },
      expression: "dataForm.commissionList"
    }
  }, _vm._l(_vm.commissionRequiredList, function (item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": "".concat(item.name, " - ").concat(_vm.percentageFormat(item.commissionRate)),
        "value": item
      }
    });
  }), 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Relationship")]), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Introducer",
      "prop": "introducer"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Who introduced this client?",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.introducer,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "introducer", $$v);
      },
      expression: "dataForm.introducer"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Marketing Tags",
      "prop": "tagIds"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.tagIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "tagIds", $$v);
      },
      expression: "dataForm.tagIds"
    }
  }, _vm._l(_vm.tagInfoList, function (item) {
    return _c('el-option', {
      key: "tag-".concat(item.id),
      attrs: {
        "label": item.tagName,
        "value": item.id
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Relationship",
      "prop": "relationshipRemark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 15,
      "autosize": {
        minRows: 14
      },
      "resize": "none",
      "placeholder": "Internal notes…"
    },
    model: {
      value: _vm.dataForm.relationshipRemark,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "relationshipRemark", $$v);
      },
      expression: "dataForm.relationshipRemark"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _c('el-card', {
    staticClass: "mt10 box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "headerWrap"
  }, [_c('span', [_vm._v("Billing Addresses")]), _c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "size": "mini"
    },
    on: {
      "click": _vm.addBillingHandle
    }
  }, [_vm._v("Add")])], 1)]), _c('div', [_c('el-form-item', {
    attrs: {
      "prop": "billingInfoList"
    }
  }, [_c('div', {
    staticClass: "itemListWrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 6
    }
  }, [_vm._v("Street Address")]), _c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 6
    }
  }, [_vm._v("Country")]), _c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 6
    }
  }, [_vm._v("Zone (manual)")]), _c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Postal / ZIP Code")])], 1), _vm._l(_vm.dataForm.billingInfoList, function (ele, index) {
    return _c('div', {
      key: "billing-".concat(index),
      staticClass: "wdb100"
    }, [_c('el-row', {
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "billingInfoList.".concat(index, ".billingAddress"),
        "rules": {
          required: true,
          message: 'please enter',
          trigger: 'submit'
        }
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Street, building, unit…",
        "clearable": ""
      },
      model: {
        value: ele.billingAddress,
        callback: function callback($$v) {
          _vm.$set(ele, "billingAddress", $$v);
        },
        expression: "ele.billingAddress"
      }
    })], 1)], 1), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "billingInfoList.".concat(index, ".billingCountry")
      }
    }, [_c('el-select', {
      staticClass: "wdb100",
      attrs: {
        "filterable": "",
        "clearable": "",
        "placeholder": "Select Country"
      },
      model: {
        value: ele.billingCountry,
        callback: function callback($$v) {
          _vm.$set(ele, "billingCountry", $$v);
        },
        expression: "ele.billingCountry"
      }
    }, _vm._l(_vm.countryList, function (item) {
      return _c('el-option', {
        key: "billing-".concat(index, "-").concat(item.value),
        attrs: {
          "label": item.title,
          "value": item.value
        }
      });
    }), 1)], 1)], 1), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "billingInfoList.".concat(index, ".billingZone")
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "e.g. Central, Admiralty…",
        "clearable": ""
      },
      model: {
        value: ele.billingZone,
        callback: function callback($$v) {
          _vm.$set(ele, "billingZone", $$v);
        },
        expression: "ele.billingZone"
      }
    })], 1)], 1), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "billingInfoList.".concat(index, ".billingPostalCode")
      }
    }, [_c('el-input', {
      attrs: {
        "clearable": ""
      },
      model: {
        value: ele.billingPostalCode,
        callback: function callback($$v) {
          _vm.$set(ele, "billingPostalCode", $$v);
        },
        expression: "ele.billingPostalCode"
      }
    })], 1)], 1), _c('el-col', {
      staticClass: "tac",
      attrs: {
        "span": 1
      }
    }, [_c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small",
        "icon": "el-icon-delete",
        "plain": ""
      },
      on: {
        "click": function click($event) {
          return _vm.deleteBillingHandle(index);
        }
      }
    })], 1)], 1)], 1);
  })], 2)])], 1)]), _c('el-card', {
    staticClass: "mt10 box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "headerWrap"
  }, [_c('span', [_vm._v("Contact Persons")]), _c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "size": "mini"
    },
    on: {
      "click": _vm.addContactHandle
    }
  }, [_vm._v("Add")])], 1)]), _c('div', [_c('el-form-item', {
    attrs: {
      "prop": "contactInfoList"
    }
  }, [_c('div', {
    staticClass: "itemListWrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 14
    }
  }, [_c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Contact Name")]), _c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 7
    }
  }, [_vm._v("Email (Receive Marketing Emails)")]), _c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Tags")]), _c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Position & Other information")])], 1), _vm._l(_vm.dataForm.contactInfoList, function (ele, index) {
    var _vm$dataForm$tagIds;

    return _c('div', {
      key: "billing-".concat(index),
      staticClass: "wdb100"
    }, [_c('el-row', {
      attrs: {
        "gutter": 14
      }
    }, [_c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('el-button', {
      staticClass: "pd0 fwb el-icon-top",
      attrs: {
        "type": "text",
        "size": "mini",
        "disabled": index == 0
      },
      on: {
        "click": function click($event) {
          return _vm.moveContact(index, -1);
        }
      }
    }), _c('el-button', {
      staticClass: "pd0 fwb el-icon-bottom",
      attrs: {
        "type": "text",
        "size": "mini",
        "disabled": index == _vm.dataForm.contactInfoList.length - 1
      },
      on: {
        "click": function click($event) {
          return _vm.moveContact(index, 1);
        }
      }
    })], 1), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "contactInfoList.".concat(index, ".contactName"),
        "rules": {
          required: true,
          message: 'please enter',
          trigger: 'submit'
        }
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Mr./Ms. Full Name",
        "clearable": ""
      },
      model: {
        value: ele.contactName,
        callback: function callback($$v) {
          _vm.$set(ele, "contactName", $$v);
        },
        expression: "ele.contactName"
      }
    })], 1)], 1), _c('el-col', {
      staticClass: "flex",
      attrs: {
        "span": 7
      }
    }, [_c('el-form-item', {
      staticClass: "wdb100 mr8",
      attrs: {
        "prop": "contactInfoList.".concat(index, ".contactEmail"),
        "rules": {
          type: 'email',
          message: 'please provide a valid email address',
          trigger: 'submit'
        }
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "email@company.com",
        "clearable": ""
      },
      model: {
        value: ele.contactEmail,
        callback: function callback($$v) {
          _vm.$set(ele, "contactEmail", $$v);
        },
        expression: "ele.contactEmail"
      }
    })], 1), _c('el-form-item', {
      attrs: {
        "prop": "contactInfoList.".concat(index, ".isReceiveEmail")
      }
    }, [_c('el-checkbox', {
      staticClass: "customLabel",
      model: {
        value: ele.isReceiveEmail,
        callback: function callback($$v) {
          _vm.$set(ele, "isReceiveEmail", $$v);
        },
        expression: "ele.isReceiveEmail"
      }
    }, [_vm._v("Receive")])], 1)], 1), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "contactInfoList.".concat(index, ".tagIds")
      }
    }, [((_vm$dataForm$tagIds = _vm.dataForm.tagIds) === null || _vm$dataForm$tagIds === void 0 ? void 0 : _vm$dataForm$tagIds.length) > 0 ? [_c('el-select', {
      staticClass: "wdb100",
      attrs: {
        "filterable": "",
        "multiple": "",
        "clearable": "",
        "placeholder": "Defaults to all marketing tags if empty"
      },
      model: {
        value: ele.tagIds,
        callback: function callback($$v) {
          _vm.$set(ele, "tagIds", $$v);
        },
        expression: "ele.tagIds"
      }
    }, _vm._l(_vm.contactTagOptions, function (item) {
      return _c('el-option', {
        key: "contact-tag-".concat(index, "-").concat(item.id),
        attrs: {
          "label": item.tagName,
          "value": item.id
        }
      });
    }), 1)] : _c('div', {
      staticClass: "pt0 pb0 tac notSelectTipBg"
    }, [_vm._v("select marketing tags first")])], 2)], 1), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "contactInfoList.".concat(index, ".contactPosition")
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 2,
        "autosize": {
          minRows: 1
        },
        "placeholder": "CEO, Manager…",
        "clearable": ""
      },
      model: {
        value: ele.contactPosition,
        callback: function callback($$v) {
          _vm.$set(ele, "contactPosition", $$v);
        },
        expression: "ele.contactPosition"
      }
    })], 1)], 1), _c('el-col', {
      staticClass: "tac",
      attrs: {
        "span": 1
      }
    }, [_c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small",
        "icon": "el-icon-delete",
        "plain": ""
      },
      on: {
        "click": function click($event) {
          return _vm.deleteContactHandle(index);
        }
      }
    })], 1)], 1)], 1);
  })], 2)])], 1)])], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }